import { useTheme } from "@mui/material/styles";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

const FooterContent = () => {
    const theme = useTheme();

    const textShadowStyle = {
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' // x-offset, y-offset, blur-radius, color
    };

    return (
        <Container maxWidth={'xl'}>
            <Grid container spacing={5} py={1}
                justifyContent={'center'} alignItems="center">
                <Grid item xs={12} md={4} sx={{ textAlign: 'left', ...textShadowStyle }}>
                    © DEDALUS Consortium 2024. All rights reserved.
                </Grid>

                <Grid item xs={12} md={8} sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyItems: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    ...textShadowStyle
                }}>
                    <Box component="img" src={'/images/eu_flag.jpg'} alt="EU Flag" sx={{ height: 24, marginRight: 2 }} />
                    Funded by the Horizon 2020 Framework Programme of the European Union under grant agreement No 101103998
                </Grid>
            </Grid>
        </Container>
    );
}

export default FooterContent;
